import TableCell from '@material-ui/core/TableCell';
import moment from 'moment';
import { TextField, MenuItem } from '@material-ui/core';


export default function field_compiler(all_fields) {
    const fields = all_fields || [];
    const styles = {
        numcol : {
            textAlign : 'right'
        }
    };
 
   
    return (selected_field) => {
        let field = fields.find(n => n.name === selected_field.name);

        //replace the label if it exists
        if(selected_field.label) field.label = selected_field.label;
        //default field type
        if(!field.type){
            field.type = 'VARCHAR';
        }
        if(!field.compileValue){
            field.compileValue = (row) => {
                return row[field.name];
            }
        }
        if(!field.render){
            //numeric fields
            if(['INT', 'DECIMAL', 'FLOAT'].indexOf(field.type.toUpperCase()) !== -1){
                field.render = (sign) => {
                    //right align numbers
                    return (<TableCell style={styles.numcol}>{field.compileValue(sign)}</TableCell>)
                }
            } else if(field.type.toUpperCase() === 'BOOLEAN'){
                field.render = (sign) => {
                    return (<TableCell>{field.compileValue(sign) ? 'Yes' : 'No'}</TableCell>)
                }
            } else if(field.type.toUpperCase() === 'DATETIME'){
                field.render = (sign) => {
                    let value = field.compileValue(sign);
                    if(!value) return (<TableCell></TableCell>);
                    let dt = moment(value);
                    let out = '';
                    if(selected_field.format && selected_field.format.toLowerCase !== 'relative'){
                        out = dt.format(selected_field.format);
                        //return(<TableCell>{dt.format(selected_field.format)}</TableCell>)
                    } else {
                        out = dt.fromNow();
                    }
                    if(out === 'Invalid date') out = 'Never';
                    return (<TableCell>{out}</TableCell>);
                }
            } else {
                field.render = (sign) => {
                    return (<TableCell>{field.compileValue(sign)}</TableCell>)
                }
            }
            
        }
        if(!field.edit){
            if(field.type === 'DATETIME'){
                field.edit = (cfg, onChange) => {
                    return (
                        <TextField
                            id="field_format"
                            label="Date Format"
                            name="format"
                            value={cfg.format || 'relative'}
                            onChange={onChange}
                            fullWidth
                            select
                        >
                            <MenuItem value='relative'>Relative</MenuItem>
                            <MenuItem value='M/DD/YYYY'>Date only</MenuItem>
                            <MenuItem value='M/DD/YYYY h:mm:ss a'>Date and Time</MenuItem>
                            <MenuItem value='YYYY-MM-DD HH:mm:ss'>ISO Timestamp</MenuItem>
                        </TextField>
                    );
                }
            } else {
                field.edit = () => {
                    return '';
                }
            }
        }
        return field;
        
    }
    
}